export type VerifyEmailResponse = {
    message: string;
    success: boolean;
};

export const sendVerifyEmail = async (token: string): Promise<VerifyEmailResponse> => {
    if (!token) {
        return {
            message: "Token no válido o ausente.",
            success: false,
        };
    }

    try {
        const res = await fetch(`/api/verify-email?token=${token}`);
        const data = await res.json();

        return {
            message: data.message || "Error desconocido.",
            success: res.ok,
        };
    } catch (error) {
        return {
            message: "Error verificando el correo. Por favor, inténtalo de nuevo.",
            success: false,
        };
    }
};
export default sendVerifyEmail
